module.exports = __webpack_public_path__ + "img/slide-logo.a05c6f9e.jpg";